export const HEARTBEAT_POLL_INTERVAL_MS = 30_000;
export const HEARTBEAT_SILENCE_THRESHOLD_MS = 60_000;

// Ingestion's stall detection budgets for this many ms between deliveries of a
// silent live run (docs/HEARTBEAT.md, "Contract with ingestion").
export const HEARTBEAT_MAX_GAP_MS = 90_000;
